import { render, staticRenderFns } from "./Spaceship.vue?vue&type=template&id=3624d4a5&scoped=true&"
import script from "./Spaceship.vue?vue&type=script&lang=js&"
export * from "./Spaceship.vue?vue&type=script&lang=js&"
import style0 from "./Spaceship.vue?vue&type=style&index=0&id=3624d4a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3624d4a5",
  null
  
)

export default component.exports